export default function DonorAccountPage() {
    return (
        <div className="container mx-auto p-8">
            <h1 className="text-3xl font-bold">My Account</h1>
            <p className="mt-4">This page will eventually allow donors to update their profile information.</p>
        </div>
    );
}